const state = {
  all: [],
  allInGroups: [],
  selected: {},
  types: [
    {
      id: 0,
      name: "Квартира",
      about: "о квартире",
      icon: "HomeIcon"
    },
    {
      id: 1,
      name: "Апартаменты",
      about: "об апартаментах",
      icon: "ApartmentIcon"
    },
    {
      id: 2,
      name: "Помещение",
      about: "о помещении",
      icon: "CommercialIcon"
    },
    {
      id: 3,
      name: "Паркинг",
      about: "о паркинге",
      icon: "ParkingIcon"
    }
  ],
  defaultType: {
    id: -1,
    name: "Объект",
    about: "об объекте"
  },
  owners: [],
  leInfo: {}
};

export default state;
